import GoogleSVG from "@design-system/ui-icons/vanilla/Google"
import { createIcon } from "../createIcon"

export const GoogleIcon = createIcon(GoogleSVG)
